'use strict';

exports.util = require('./util.js');
exports.resolver = require('./resolver.js');
exports.codec = exports.util.codec;
exports.defaultHashAlg = exports.util.defaultHashAlg;